<div class="manual-kyb-people">
  @if (showWaitingMessage) {
    <message-box type="warn">
      Business verification is still in progress. Add the people authorised to act for this business
      so you can continue. Verification will continue in the background.
    </message-box>
  }

  @for (row of rows; track row.clientId; let index = $index) {
    <section class="manual-person">
      <div class="manual-person-heading">
        <h3>Person {{ index + 1 }}</h3>
        <button type="button" mat-button color="warn" (click)="removePerson(row)">Remove</button>
      </div>
      <div class="manual-person-roles">
        <mat-checkbox [(ngModel)]="row.isGuarantor" [disabled]="lockRoles" (change)="onRoleChange()">Guarantor</mat-checkbox>
        <mat-checkbox [(ngModel)]="row.isSigner" [disabled]="lockRoles" (change)="onRoleChange()">Signer</mat-checkbox>
      </div>
      <individual-form
        [formControl]="row.control"
        [roleLabel]="null"
        [showResidencyProofAlert]="row.isGuarantor"
        [idDocumentProvided]="row.idDocumentProvided"
        [existingIdDocuments]="row.uploadedIdDocuments"
        (idDocumentDelete)="onIdDocumentDelete(row, $event)">
      </individual-form>
    </section>
  }

  @if (maxPeople == null || rows.length < maxPeople) {
    <button
      type="button"
      class="add-person-button"
      mat-stroked-button
      color="primary"
      (click)="addPerson()">
      Add person
    </button>
  }

  @if (showValidation && !rows.length) {
    <message-box type="danger">Enter at least one person.</message-box>
  }
  @if (showValidation && rows.length && !hasSigner) {
    <message-box type="danger">Select at least one signer.</message-box>
  }
</div>
